<i-check *ngIf="isNeutral || isValid"
    [class.is--valid]="isValid"></i-check>

<i-x *ngIf="isInvalid"
    [class.not--valid]="true"></i-x>
